import { Box, styled, Typography } from "@material-ui/core";
import ImageRenderer from "../../../../components/src/ImageRenderer.web";
import React from "react";
import { icLock } from "../../../../blocks/chat/src/assets";

interface IPropsSubscribeGroup {
    onRequestSubscribeGroup: () => Promise<void>;
}

const SubscribeGroup: React.FC<IPropsSubscribeGroup> = ({
    onRequestSubscribeGroup,
}) => {
    return (
        <SubscribeGroupStyled>
            <ImageRenderer src={icLock} width={55} height={55} />
            <Typography variant="h4">
                "If you wish to read more within the group, you must first subscribe."
            </Typography>
            <Box className="subscribeBtn" onClick={onRequestSubscribeGroup}>
                Subscribe
            </Box>
        </SubscribeGroupStyled>
    )
};

const SubscribeGroupStyled = styled(Box)(() => ({
    position: "absolute",
    display: "flex",
    width: "100%",
    flexDirection: "column",
    alignItems: "center",
    height: 161,
    top: -150,
    "& h4": {
        fontFamily: "Manrope",
        fontWeight: 600,
        fontSize: 16,
        color: "#FFF",
        textAlign: "center",
        marginTop: 15,
    },
    "& .subscribeBtn": {
        padding: "6px 10px",
        cursor: "pointer",
        marginTop: 20,
        borderRadius: 8,
        background: "linear-gradient(330.07deg, #3858E3 -51.03%, #BA05F7 138.78%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "Manrope",
        fontWeight: 700,
        fontSize: 14,
        color: "#FFF"
    },
}))

export default SubscribeGroup